'use client'

import { Stack } from '@mui/material'
import { ListAccountOrders, Section } from '@wolfdanepug/common-react'
import OrderItem from '../../../components/order/OrderItem'
import { useQuery } from '../../../lib/useQuery'
import { useContext, useEffect } from 'react'
import { PageContext } from '../../../context/page'

export default function Page() {
	const { data } = useQuery(ListAccountOrders)
	const { setPage } = useContext(PageContext)

	useEffect(() => {
		setPage({
			title: 'Order History',
			description: 'View your order history',
			canGoBack: '/settings'
		})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const orders = data?.items || []

	return (
		<>
			<Section sx={{ container: { pt: 3 } }}>
				<Stack spacing={2} sx={{ width: '100%' }}>
					{orders.length > 0 &&
						orders.map((order: any, index: number) => (
							<OrderItem key={order.id} item={order} index={index + 1} />
						))}
				</Stack>
			</Section>
		</>
	)
}
